/*
 * Copyright (C) 2024 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and
 * should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly
 * prohibited.
 */

import {
  GridSlotsComponentsProps,
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbarFilterButton,
  GridToolbarQuickFilter,
} from '@mui/x-data-grid';
import styled from 'styled-components';
import React from 'react';

const StyledGridToolbarContainer: typeof GridToolbarContainer = styled(GridToolbarContainer)`
  padding: 8px 0 8px;
`;

export interface CustomGridToolbarProps {
  disableQuickFilter?: boolean;
  disableFilterButton?: boolean;
  disableExportButton?: boolean;
  slotProps?: GridSlotsComponentsProps;
}

const CustomGridToolbar: React.FC<CustomGridToolbarProps> = props => {
  return (
    <StyledGridToolbarContainer>
      {!props.disableQuickFilter && (
        <GridToolbarQuickFilter
          placeholder={'Search for anything...'}
          variant={'outlined'}
          size={'small'}
          {...props.slotProps?.toolbar?.quickFilterProps}
        />
      )}
      {!props.disableFilterButton && <GridToolbarFilterButton />}
      {!props.disableExportButton && <GridToolbarExport csvOptions={props.slotProps?.toolbar?.csvOptions} />}
      {props.children}
    </StyledGridToolbarContainer>
  );
};

CustomGridToolbar.defaultProps = {
  disableQuickFilter: false,
  disableFilterButton: false,
  disableExportButton: false,
};

export default CustomGridToolbar;
